export default function IconGalleryUltimate() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			id="Picture-Polaroid-Landscape--Streamline-Ultimate"
			height="100%"
			width="100%"
		>
			<desc>{'\n    Picture Polaroid Landscape Streamline Icon: https://streamlinehq.com\n  '}</desc>
			<defs />
			<title>{'picture-polaroid-landscape'}</title>
			<path
				d="m15.543 15.543 -2.628 -6.571c-0.2 -0.511 -0.558 -0.519 -0.785 -0.018l-2.087 4.589 -1.859 -2.231a0.667 0.667 0 0 0 -1.155 0.089l-2.486 4.142"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="M2.543 1.543h15s1 0 1 1v15s0 1 -1 1h-15s-1 0 -1 -1v-15s0 -1 1 -1"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="m20.551 7.424 1 0.091a1 1 0 0 1 0.901 1.085l-1.181 12.948a1 1 0 0 1 -1.087 0.9L6.243 21.18"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path d="m1.543 15.543 17 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path
				d="M4.543 6.043a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
		</svg>
	);
}
